import { inject, Pipe, type PipeTransform } from '@angular/core';
import { AuthenticationService } from '@modules/authentication/services/authentication.service';
import { ChannelUser } from '@pixacare/chat';

@Pipe({
  name: 'chatHideMyself',
  standalone: true,
})
export class ChatHideMyselfPipe implements PipeTransform {
  private authenticationService = inject(AuthenticationService);

  transform(value: ChannelUser[]): ChannelUser[] {
    return value?.filter((user) => user.id !== this.authenticationService.user.id);
  }
}
